import authenticatedHttpClientFactory from '@/modules/core/services/authenticatedHttpClientFactory';
import { toDate, toDateFromPtBr } from '@/modules/core/utils/formats';

export const getPaginatedExPagantesData = async(options) => {
  const params = getParams(options);
  params.pagina = options.page;
  params.porPagina = 10;
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get(`admin/exPagantes?${new URLSearchParams(params).toString()}`);
  return response.data;
};

export const getAllExPagantesData = async(options) => {
  const params = getParams(options);
  params.pagina = 1;
  params.porPagina = 1000000;
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get(`admin/exPagantes?${new URLSearchParams(params).toString()}`);
  return response.data.dados.map((data) => [
    `"${data.empresa}"`,
    `"${data.celular}"`,
    `"${toDate(data.dataCadastro)}"`,
    `"${data.tipoAssinatura}"`,
    `"${toDate(data.expiradaEm)}"`,
    `"${toDate(data.ultimaRenovacao)}"`,
    data.plataforma != null ? `"${data.plataforma}"` : '',

  ]);
};

const getParams = (options) => ({
  ordem: options.order,
  ordenarPor: options.sort,
  pesquisar: options.search,
  dataCadastroInicial: toDateFromPtBr(options.dataCadastroInicial),
  dataCadastroFinal: toDateFromPtBr(options.dataCadastroFinal),
  expiradaEmInicial: toDateFromPtBr(options.expiradaEmInicial),
  expiradaEmFinal: toDateFromPtBr(options.expiradaEmFinal),
  ultimaRenovacaoInicial: toDateFromPtBr(options.ultimaRenovacaoInicial),
  ultimaRenovacaoFinal: toDateFromPtBr(options.ultimaRenovacaoFinal),

});
